import { render, staticRenderFns } from "./limit-select.vue?vue&type=template&id=ff7bd7de&"
import script from "./limit-select.vue?vue&type=script&lang=js&"
export * from "./limit-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports